import { IAgentSchema } from '../repositories/favorites/entities/agent/AgentSchema';
import { IBargainTermsForDesktopSchema } from '../repositories/favorites/entities/favorite_entity_for_desktop/BargainTermsForDesktopSchema';
import { ICommercialInfoSchema } from '../repositories/favorites/entities/favorite_entity_for_desktop/CommercialInfoSchema';
import { IFlatInfoSchema } from '../repositories/favorites/entities/favorite_entity_for_desktop/FlatInfoSchema';
import { IGeoForDesktopSchema } from '../repositories/favorites/entities/favorite_entity_for_desktop/GeoForDesktopSchema';
import { IJKInfoSchema } from '../repositories/favorites/entities/favorite_entity_for_desktop/JKInfoSchema';
import { ISuburbanInfoSchema } from '../repositories/favorites/entities/favorite_entity_for_desktop/SuburbanInfoSchema';
import {
  EDealType,
  EStatus,
} from '../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';

export enum EEntityType {
  /** Коммерческая **/
  Commercial = 'commercial',
  /** ЖК **/
  Newbuilding = 'newbuilding',
  /** Жилая **/
  Residential = 'residential',
  /** Загородка **/
  Suburban = 'suburban',
}

export interface IFavoriteEntity {
  /** Информация об агенте **/
  agentInfo?: IAgentSchema | null;
  /** Информация о цене **/
  bargainTerms: IBargainTermsForDesktopSchema;
  /** ИД категории для определния типа жалоб **/
  categoryComplaintId?: number | null;
  /** Информация о коммерческой недвижимости **/
  commercialInfo?: ICommercialInfoSchema | null;
  /** Тип сделки **/
  dealType: EDealType;
  /** Дата когда объявление удалится, только для снятых с публикаци **/
  deleteDate?: string | null;
  /** Описание **/
  description?: string | null;
  /** Cian Id объекта (объявка/ЖК) **/
  entityId: number;
  /** Cian Id объекта (объявка/ЖК) **/
  entityCianId: number;
  /** Тип объекта (объявка/ЖК) **/
  entityType: EEntityType;
  /** Информация о жилой недвижимости **/
  flatInfo?: IFlatInfoSchema | null;
  /** Ссылка на объект **/
  fullUrl: string;
  /** Информация о Гео **/
  geo: IGeoForDesktopSchema;
  /** Информация о ЖК **/
  jkInfo?: IJKInfoSchema | null;
  /** Текст заметки **/
  note?: string | null;
  /** Телефон **/
  phone?: string | null;
  /** URL исходного изображения **/
  photoFullUrl?: string | null;
  /** Статус **/
  status?: EStatus | null;
  /** Информация о загородной недвижимости **/
  suburbanInfo?: ISuburbanInfoSchema | null;
  /** Заголовок объекта **/
  title: string;
}

export interface IFavoritesFolder {
  clientId?: number | null;
  id: number;
  imageUrl?: string | null;
  name: string;
  description: string;
  offersCount: number;
}
